<h2>Todo details</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form">
    <mat-form-field class="form-field">
        <mat-label>title</mat-label>
        <input matInput placeholder="write the title" value="" formControlName="title">
    </mat-form-field>

    <mat-form-field class="form-field">
        <mat-label>description</mat-label>
        <input matInput placeholder="and add some description" value="" formControlName="description">
    </mat-form-field>

    <mat-form-field class="form-field">
        <mat-label>status</mat-label>
        <mat-select matInput formControlName="isCompleted">
          <mat-option value="false">pending</mat-option>
          <mat-option value="true">completed</mat-option>
        </mat-select>
    </mat-form-field>


    <div class="button-container">
        <button mat-raised-button type="button" (click)="onDelete()">
            delete
        </button>
        <button mat-raised-button type="submit" [disabled]="form.invalid">
            edit
        </button>
    </div>

</form>